/**
 * Страница Services (02_GPT-MODULAR).
 * Только сетка карточек. Плашка остаётся в LayoutWithPlank.
 */

import ChatbotsCard from "../components/ServiceCards/ChatbotsCard";
import MiniAppsCard from "../components/MiniAppsCard/MiniAppsCard";
import AiCard from "../components/ServiceCards/AiCard";
import SoftwareCard from "../components/ServiceCards/SoftwareCard";
import WebsitesCard from "../components/ServiceCards/WebsitesCard";
import UiUxCard from "../components/ServiceCards/UiUxCard";
import DevopsCard from "../components/ServiceCards/DevopsCard";

function ServicesPage() {
    return (
        <div className="group-9">
            <ChatbotsCard />
            <MiniAppsCard />
            <AiCard />
            <SoftwareCard />
            <WebsitesCard />
            <UiUxCard />
            <DevopsCard />
        </div>
    );
}

export default ServicesPage;
// pages/ServicesPage.js
